export default __webpack_public_path__ + "static/media/telegram.95198a5b.png";